import useConnectRedirection from 'utils/useConnectRedirection';

const App = (): null => {
  useConnectRedirection();
  return null;
};

export default App;
